'use client';

/**
 * Binary Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { WhySoftwareSection } from '../common/why-software-section';
import { WhatIsSoftwareSection } from '../common/what-is-software-section';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { HowItWorksSection } from './HowItWorksSection';

interface MLMPlan {
    slug: string;
    name: string;
    description: string;
    content: string;
    image?: string;
    features?: string[];
}

interface PlanDetailContentProps {
    plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            <PlanIntroSection
                plan={plan}
                translationNamespace="planDetails.binaryPlan.hero"
                imageSrc="/images/mlm-plans/Binary_animate.gif"
                descriptionKeys={['description']}
            />
            <WhatIsPlanSection plan={plan} />
            <WhatIsSoftwareSection
                plan={plan}
                translationNamespace="planDetails.binaryPlan.whatIsSoftware"
                imageSrc="/images/mlm-plans/mlm-software-demo.webp"
                descriptionKeys={['description']}
            />
            <HowItWorksSection plan={plan} />
            <FeaturesSection plan={plan} translationNamespace="planDetails.binaryPlan.features" />
            <WhySoftwareSection plan={plan} translationNamespace="planDetails.binaryPlan.whySoftware" />
        </div>
    );
}
